// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
//import { VueJsonp } from 'vue-jsonp';

import i18n from './i18n/i18n'
import "../static/css/theme.css"

import 'element-ui/lib/theme-chalk/index.css'

import axios from 'axios'

//axios.defaults.baseURL = 'http://localhost:8080'
//axios.defaults.baseURL = 'https://pummmm.com/'
Vue.prototype.$axios = axios
Vue.config.productionTip = false

Vue.use(ElementUI)
//Vue.use(VueJsonp)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  i18n
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js